<template>
  <div>
    <p v-if="isLoading">Загрузка...</p>
    <b-table-simple v-else bordered="">
      <b-thead head-variant="light">
        <b-tr>
          <b-th>#</b-th>
          <b-th>Название ДО</b-th>
          <b-th>Дата прибытия</b-th>
          <b-th>Дата выбытия</b-th>
          <b-th>Время прибывание</b-th>
          <b-th>Образовательный вид</b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="(data, index) in childUsedKindergartenList" :key="index">
          <b-tr>
            <b-td>{{ index + 1 }}</b-td>
            <b-td>{{ data.kindergartenName }}</b-td>
            <b-td>{{ data.arrivedDate }}</b-td>
            <b-td>{{ data.departureDate }}</b-td>
            <b-td>{{ data.durationTimeName }}</b-td>
            <b-td>{{ data.educationalTypeName }}</b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {ChildUsedKindergartenResponse} from "@/types/childrenResponse";
import {useRoute} from "vue-router";
import {getChildrenKindergartens} from "@/services/childrenService";

export default defineComponent({
  name: 'ChildrenKindergartenView',
  setup() {
    const childUsedKindergartenList = ref<ChildUsedKindergartenResponse[]>([]);
    const childId = ref<string>("");
    const isLoading = ref(false);

    const fetchData = async () => {
      isLoading.value = true;
      try {
         childUsedKindergartenList.value = await getChildrenKindergartens(childId.value);
      } catch (error) {
        console.error("Error fetching child short info list:", error);
      }
      isLoading.value = false;
    }

    onMounted(() => {
      const route = useRoute();
      childId.value = route.params.id as string;
      fetchData();
    });

    return {
      isLoading,
      childUsedKindergartenList,
    }
  }
})
</script>

<style scoped></style>